module.exports = __webpack_public_path__ + "static/media/tui-logo.d902781f.svg";